export default {
  guideContract_DefaultPaperContract: '発注書兼請書：紙契約',
  guideContract_PaperContract: '紙契約',
  guideContract_SignRequired: '要署名',
  guideContract_Newbie: '新人ガイド',
  guideContract_FormContract: '契約書に含む',
  guideContract_SignContractModalTitle: '契約ページ',
  guideContractList_PageTitle: '紙契約',
  guideContractList_TourName: 'ツアー名',
  guideContractList_GuideName: 'ガイド名',
  guideContractList_AGTName: 'AGT名',
  guideContractList_GuideStatus: 'ガイドSTS',
  guideContractList_TourID: 'ツアーID',
  guideContractList_TourNo: 'ツアーNo',
  guideContractList_TourFrom: 'ツアー期間(From)',
  guideContractList_TourTo: 'ツアー期間(To)',
  guideContractList_FileName: 'ファイル名',
  guideContractList_ContractFrom: '契約確認期間(From)',
  guideContractList_ContractTo: '契約確認期間(To)',
  guideContractList_SalePIC: '営業担当',
  guideContractList_SupperAccount: '経理担当',
  guideContractList_ContractStatus: '契約確認STS',
  guideContractList_ConfirmedDate: '最新確認日',
  GuideContractListingPage_PageTitle: 'ガイド契約一覧',
};
